import { render, staticRenderFns } from "./pfollow.vue?vue&type=template&id=7aa991c4&scoped=true&"
import script from "./pfollow.vue?vue&type=script&lang=js&"
export * from "./pfollow.vue?vue&type=script&lang=js&"
import style0 from "./pfollow.vue?vue&type=style&index=0&id=7aa991c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa991c4",
  null
  
)

export default component.exports